// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout-module--container--W3sEX"};